<template>
    <div class="basic">
      <el-header style="margin:1rem 0 0 0;">
        <tab-switch :button-names-arr="tabArr" @curTabButtonClickDeal="onTabChange"></tab-switch>
      </el-header>
      <div style="height: calc(100% - 8rem);width: 100%" >

        <div v-if="onShow"  class="basic" >
          <el-row style="height: 7rem;display: flex;align-items: center">
            <el-col :span="24">
                <div class="showSearch" style="margin-left: 2rem" >
                  <el-select  :value="xItem" @change="onXItemChange" placeholder="x轴关联数据项" size="small">
                    <el-option
                        v-for="item in opts"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                  </el-select>
                  <el-select class="searchButton" v-model="xMpcd" filterable placeholder="x轴测点" size="small">
                    <el-option
                        v-for="item in xMps"
                        :key="item.mpcd"
                        :label="item.mpcd"
                        :value="item.mpcd">
                    </el-option>
                  </el-select>
                  <el-select class="searchButton" :value="yItem" @change="onYItemChange" placeholder="y轴关联数据项" size="small">
                    <el-option
                        v-for="item in opts"
                        :key="item.code"
                        :label="item.name"
                        :value="item.code">
                    </el-option>
                  </el-select>
                  <el-select class="searchButton" v-model="yMpcd"   filterable placeholder="y轴测点" size="small">
                    <el-option
                        v-for="item in yMps"
                        :key="item.mpcd"
                        :label="item.mpcd"
                        :value="item.mpcd">
                    </el-option>
                  </el-select>
                  <el-date-picker
                      size="small"
                      v-model="dateTime"
                      type="daterange"
                      range-separator="-"
                      start-placeholder="开始日期"
                      end-placeholder="结束日期"
                      class="searchDate"
                      value-format="yyyy-MM-dd"
                      :clearable="false"
                  >
                  </el-date-picker>
                  <el-button type="primary" size="small" class="searchButton" @click="queryData()">
                    分析
                  </el-button>
                </div>
            </el-col>
          </el-row>
          <el-row style="height: calc(100% - 7rem)">
          <el-col :span="12" style="height: 100%">
                  <v-chart :key="chartKey" class="chartStyle"  ref="compChart" :option = " {
                      /*title: {
                        text: 'Linear Regression',
                        subtext: 'By ecStat.regression',
                        left: 'center'
                      },
                      legend: {
                        bottom: 5
                      },*/

                      tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                          type: 'cross'
                        }
                      },
                      toolbox: {
                        show: true,
                        orient: 'vertical',
                        left: 'right',
                        top: 'center',
                        feature: {
                          saveAsImage: { show: true },  // 保存图表
                        },
                      },
                      xAxis: {
                        splitLine: {
                          lineStyle: {
                            type: 'dashed'
                          }
                        },
                        data: xAxisData
                      },
                      yAxis: {
                        splitLine: {
                          lineStyle: {
                            type: 'dashed'
                          }
                        },
                        axisLabel: {
                          formatter: '{value}',
                        },
                        min: min,
                        max: max
                      },
                      series: [
                        {
                           type: 'line',
                           smooth: true,
                          datasetIndex: 1,
                          symbolSize: 10,
                          data: chartData,
                          name: realDataName,
                          color: 'rgb(165,42,34)'
                        },
                        {
                          type: 'line',
                          data: lineData,
                          name: equationName,
                           color: 'rgb(82,162,134)'
                        }
                      ]
                    }" ></v-chart>
          </el-col>
          <el-col :span="12" style="height: 100%;padding-left: 2rem;padding-right: 2rem" >
            <div ref="dataShow" style="width: 100%;height: 100%">
              <div style="width: 100%;height:3.2rem;display: flex;align-items: center;color: #000;background-color: rgb(247,247,247);">
                <img class="searhInput" src="../../assets/icons/monitor/result.png" alt=""/>
                <span class="my-font">分析结果</span>
  <!--              <span style="font-size: 1.5rem;padding-left: 1rem">{{conclusion}}</span>-->
              </div>
              <el-descriptions style="width: 100%;margin-bottom: 1rem;height: 9.7rem"   :column="2" border>
                <el-descriptions-item
                    :label-style="{textAlign:'center',fontSize: '1.4rem',color: '#000',fontWeight:'bold'}"
                              label="相关系数">{{conclusionData.a}}</el-descriptions-item>
                <el-descriptions-item :label-style="{textAlign:'center',fontSize: '1.4rem',color: '#000',fontWeight:'bold'}"
                                      label="拟合方程">{{conclusionData.linearEquation}}</el-descriptions-item>
                <el-descriptions-item :label-style="{textAlign:'center',fontSize: '1.4rem',color: '#000',fontWeight:'bold'}"
                                      label="判断结果">{{conclusionData.conclusion }}</el-descriptions-item>
              </el-descriptions>
<!--              <el-table
                  ref="conclusionTable"
                  :data="conclusionData"
                  border
                  style="width: 100%;margin-bottom: 1rem;">

                <el-table-column
                    property="a"
                    label="相关系数"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    property="linearEquation"
                    label="拟合方程"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    property="conclusion"
                    label="判断结果"
                    align="center"
                >
                </el-table-column>
              </el-table>-->
              <div style="height:3.5rem;display: flex;align-items: center">
                <img class="searhInput" src="../../assets/icons/monitor/collect.png" alt=""/>
                <span class="my-font">分析结果列表</span>
              </div>
              <el-table
                  :data="tableData"
                  height ="calc(100% - 17.4rem)"
                  border
                  size="small"
                  style="width: 100%;">
                <el-table-column
                    property="dt"
                    label="时间"
                    align="center"
                >
                </el-table-column>

                <el-table-column
                    property="x"
                    label="x轴关联数据项"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    property="y"
                    label="y轴关联数据项"
                    align="center"
                >
                </el-table-column>

              </el-table>
            </div>
<!--              <div class="pageStyle">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                    :page-sizes="[10, 20, 30]"
                    :page-size="params.size"
                    :current-page="params.current"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
              </div>-->
          </el-col>
        </el-row>
        </div>
        <div v-else  class="basic" >
          <saturantion />
        </div>
      </div>
    </div>
</template>
<script setup>
  import {dateTimeToString} from "../../utils/dateUtils";
  // import ecStat from 'echarts-stat';
  import VChart from "vue-echarts";
  import TabSwitch from "../../components/buttonGather/tabSwitch";
  import Saturantion from "./saturation";
 /* import {use} from "echarts/core";
  import {LineChart,ScatterChart} from "echarts/charts";
  import {CanvasRenderer} from "echarts/renderers";
  import {GridComponent, LegendComponent, ToolboxComponent, TooltipComponent,} from "echarts/components";

  use([
    CanvasRenderer,
    GridComponent,
    TooltipComponent,
    ScatterChart,
    ToolboxComponent,
    LegendComponent,
    LineChart
  ]);*/

  export default {
    name:'compQuery',
    components: {Saturantion, VChart,TabSwitch},
    data() {
      return {
        tabArr:['浸润线','相关性分析'],
        detailShow: false,
        lineData:[],
        chartData:[],
        xAxisData: [],
        tableData: [],
        currentRow: null,
        conclusionData:{},
        dateTime: [],
        params:{current: 1,size: 12},
        total: 0,
        xMps:[],
        yMps:[],
        xItem: null,
        yItem: null,
        xMpcd: null,
        yMpcd: null,
        opts : [],
        conclusion: '',
        equationName:'',
        realDataName: '',
        chartKey: 0,
        onShow: false,
        min: 0,
        max: 0
      }
    },
    created() {
      const now = new Date();
      const start = new Date(now.getTime() - 14*24*3600000);
      const nowStr = dateTimeToString(now,false);
      const startStr = dateTimeToString(start,false);
      this.dateTime = [startStr,nowStr];
    },
    mounted() {
      window.addEventListener("resize", this.onWindowResize, false);

      // this.queryData();
      this.initCondition();
      this.calHeight();
    },
    beforeDestroy() {
    },
    methods: {
      reset(){
        this.xItem = null;
        this.yItem = null;
        this.xMpcd = null;
        this.yMpcd = null;
        this.conclusionData = {};
        this.lineData = [];
        this.chartData = [];
        this.xAxisData =  [];
        this.tableData = [];
      },
      removeResize(){
        window.removeEventListener("resize",this.onWindowResize);
      },
      initCondition(){
        this.request.get('/rm-sdictionary/v1/query/06').then(res =>{
          if(res.ok){
            this.opts = res.data;
          }else {
            this.$message.error(res.error.message);
          }
        });
      },
      onYItemChange(val){
        for(let opt of this.opts){
          if(val === opt.code){
            this.realDataName = opt.name;
          }
        }
        this.yItem = val;
        const params = {type: val};
        if(this.yMpcd){
          this.yMpcd = null;
        }
        this.request.get('/rm-bmp/queryMpOrStbprp',{params}).then(res =>{
          if(res.ok){
            this.yMps = res.data;
          }else {
            this.$message.error(res.error.message);
          }
        });
      },
      onXItemChange(val){
        this.xItem = val;
        const params = {type: val};
        if(this.xMpcd){
          this.xMpcd = null;
        }
        this.request.get('/rm-bmp/queryMpOrStbprp',{params}).then(res =>{
            if(res.ok){
              this.xMps = res.data;
            }else {
              this.$message.error(res.error.message);
            }
        });
      },
      handleSizeChange(size){
        this.params.size = size;
        this.queryData();
      },
      handlePageChange(page){
        this.params.current = page;
        this.queryData();
      },
      onWindowResize(){
        this.calHeight();
      },
      calHeight(){
        this.chartKey++;
      },
      queryData(){
        if(!this.xItem){
          this.$message.warning('请先选择x轴监测项目');
          return;
        }
        if(!this.yItem){
          this.$message.warning('请先选择y轴监测项目');
          return;
        }
        if(!this.xMpcd){
          this.$message.warning('请先选择x轴测点');
          return;
        }
        if(!this.yMpcd){
          this.$message.warning('请先选择y轴测点');
          return;
        }
        const params = {xmpcd: this.xMpcd,ympcd: this.yMpcd,xmstp: this.xItem,ymstp: this.yItem,mstmGE: this.dateTime[0],mstmLE: this.dateTime[1]};

        // const params = {xMpcd: this.xMpcd,mstmGE: this.dateTime[0],mstmLE: this.dateTime[1]};
        this.request.post('/rm-dst/dataAnalyse',params).then(res =>{
          if(res.ok){
            const data = res.data;
            this.xAxisData = data.xvoList;
            this.lineData = data.zvoList;
            this.chartData = data.yvoList;
            this.tableData = data.dataAnalyseDataVo;
            const linear = data.linearEquationDto;
            this.equationName = linear.linearEquation;
            this.conclusionData = linear;

            this.max = Math.ceil(parseFloat(data.maxY));
            this.min = Math.floor(parseFloat(data.minY));
          }else {
            this.$message.error(res.error.message);
          }
        });
      },
      onTabChange(key){
        this.onShow = key;
        if(key){
          this.removeResize();
        }
        /*if(key === 1){
          this.onShow = false;
        }else {
          this.onShow = true;
        }*/
      },
    },
    watch: {
      "$store.state.head.skCd"() {
        this.reset();
        this.initCondition();

      }
    }
}
</script>
<style scoped>
  .basic{
    width: 100%;
    height: 100%;
  }
  .my-font{
    font-family: "PingFang SC";
    font-size: 1.5rem;
    color: black;
    background-color: rgb(247,247,247);
    font-weight: bold;
    margin-left: 0.5rem;
  }
  .showSearch{
    display: flex;
    flex-direction: row;
  }
  .searhInput{
    margin-left: 1rem;
  }
  .searchDate{
    width: 36rem;
    margin-left: 1.5rem;
  }
  .searchButton{
    margin-left: 1.5rem;
  }
  .showData{
    height: calc(100% - 15rem);
    width: 100%;
  }
  .activeButton{
    background-color: #409EFF;
    border-color: #409EFF;
    width: 9.2rem;
  }
  .normalButton{
    background-color: #ecf5ff;
    border-color: #b3d8ff;
    color: #409eff;
    width: 9.2rem;
  }
  .pageStyle{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .tableDiv{
    width: 100%;
    height: calc(100% - 2.5rem);
  }
  .chartStyle{
    width: 100%;
    height: 100%;
  }
</style>
